// extracted by mini-css-extract-plugin
export var promotionLink = "_vk-0";